import React from 'react'

interface PauseButtonProps {
  onClick: () => void
  size: 'sm' | 'lg' | 'header'
}

export function PauseButton({ onClick, size }: PauseButtonProps) {
  if (size === 'sm') {
    return (
      <button
        onClick={onClick}
        className={`
          h-9 p-2 rounded-md justify-start items-center gap-4 inline-flex group
          hover:scale-125 transition-transform duration-100
        `}
      >
        <span className="sr-only">Pause capture</span>
        <div className="w-5 h-5 relative">
          <div className="w-[18px] h-[18px] left-px top-px absolute bg-primary rounded-full border border-secondary" />
          <div
            className={`
              w-2.5 h-2.5 left-[5px] top-[5px] absolute bg-danger-icon rounded-sm
              group-active:scale-110 transition-all duration-100
            `}
          />
        </div>
      </button>
    )
  } else if (size === 'header') {
    // Smaller size for header to match text height
    return (
      <button onClick={onClick} className="w-6 h-6 flex justify-center items-center">
        <span className="sr-only">Pause capture</span>
        <div className="w-6 h-6 relative">
          <div className="w-6 h-6 left-0 top-0 absolute bg-white rounded-full border border-[#c6cdd2]" />
          <div className="w-[14px] h-[14px] left-[5px] top-[5px] absolute flex items-center justify-center gap-[2px]">
            <div className="w-[3px] h-[8px] bg-[#e22f4f] rounded-[0.5px]" />
            <div className="w-[3px] h-[8px] bg-[#e22f4f] rounded-[0.5px]" />
          </div>
        </div>
      </button>
    )
  } else {
    // size === 'lg'
    return (
      <button onClick={onClick} className="w-10 h-10 flex-col justify-start items-start inline-flex">
        <span className="sr-only">Pause capture</span>
        <div className="w-10 h-10 relative">
          <div className="w-[46px] h-[46px] left-[-3px] top-[-3px] absolute bg-white rounded-full border-2 border-white" />
          <div className="w-10 h-10 left-0 top-0 absolute bg-white rounded-full border-2 border-[#c6cdd2]" />
          <div className="w-5 h-5 left-[10px] top-[10px] absolute flex items-center justify-center gap-[3px]">
            <div className="w-[5px] h-[14px] bg-[#e22f4f] rounded-[1px]" />
            <div className="w-[5px] h-[14px] bg-[#e22f4f] rounded-[1px]" />
          </div>
        </div>
      </button>
    )
  }
}
